import * as Yup from 'yup';

const validationSchema = Yup.object({
    email: Yup.string()
        .required('E-mail obrigatório')
});

export default validationSchema;